import React, { memo } from "react";
import { Stock } from "../common/Icon";
import FormSteps from "./FormSteps";

function FormStatic({ selectedList }) {
  return (
    <>
      <h1>生地サンプル請求</h1>
      <FormSteps />
      <div className="sample_thumbs">
        <b>選択中の生地サンプル</b>
        <ul>
          {selectedList.map((item, i) => {
            return (
              <li key={i}>
                <img
                  src={`/material/images/wave/thumb/${item.code}.jpg`}
                  alt=""
                />
                <Stock data={item.stock} />
              </li>
            );
          })}
        </ul>
      </div>
    </>
  );
}

export default memo(FormStatic);
